import { useQuery } from "react-query";
import { QUERY_STALE_TIME } from "utils/constants";
import { useAccessToken } from "hooks/useAccessToken";
import { useCallback } from "react";
import useFilters from "recoilStore/useFilters";
import queryFn from "ApiLayer/queryBuildingModelsTable";
import { filterTableData } from "utils/helpers";
import useUniqueTags from "recoilStore/useUniqueTags";

export const useBuildingModelsTableQuery = () => {
    const accessToken = useAccessToken();

    const { filters: clientFilters, numberOfFilters } = useFilters();
    const { setTags } = useUniqueTags();

    const onSuccess = (datum: BuildingModelsTableDatum[]) => {
        const uniqueTags = Array.from(new Set(datum.flatMap(({ tags }) => tags)));
        uniqueTags.sort((a, b) => a.trim().localeCompare(b.trim()));
        setTags({ tags: Array.from(uniqueTags) });
    };

    const selectBuildingModels = useCallback(
        (datum: BuildingModelsTableDatum[]) => filterTableData(datum, clientFilters, numberOfFilters),
        [clientFilters]
    );

    return useQuery({
        queryKey: ["buildingModelsTable"],
        queryFn: async () => queryFn(accessToken, onSuccess),
        staleTime: QUERY_STALE_TIME,
        select: selectBuildingModels,
    });
};
